import React from 'react';
import StandaloneView from 'views/Standalone';
import StandaloneLayout from 'layouts/Standalone';
import WithLayout from 'WithLayout';

const Standalone = ({pageContext, children}) => (
  <WithLayout component={StandaloneView} layout={StandaloneLayout} pageContext={pageContext}>
    {children}
  </WithLayout>
);

export default Standalone;
